import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  LENDER_PORTAL_LENDING_PROGRAM_REDUCER_PATH,
  LENDING_PROGRAM_RELATED_TAGS,
} from "@/features/LendingProgram/utils/lendingProgramServiceTags";

export const capworksProgramService = createApi({
  reducerPath: LENDER_PORTAL_LENDING_PROGRAM_REDUCER_PATH,
  tagTypes: LENDING_PROGRAM_RELATED_TAGS,
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/capworks/",
    credentials: "include",
  }),
  endpoints: () => ({}),
});

